export enum UserRole {
  DEV = "DEV", ADMIN = "ADMIN", USER = "USER"
}
